import type { ModeloDeRelease, ReleaseDeFirmware } from '@/api/robo'

/**
 * As releases acima da homologada mais nova, da mais nova para a mais velha
 * (o changelog já vem nessa ordem). Sem nenhuma homologada, nenhuma é
 * candidata: o alvo da frota volta a ser o topo, como no backend
 * (`releases.classificar`, spec 2026-10-02, 4.3).
 */
export function candidatas(modelo: ModeloDeRelease): ReleaseDeFirmware[] {
  const i = modelo.releases.findIndex((r) => r.homologada)
  return i < 0 ? [] : modelo.releases.slice(0, i)
}
